<template>
  <app-chart-wrapper>
    <div class="card-header flex-space-between">
      <div>{{$t('message.statistics.message.screenTime')}}: {{screenTime}}s</div>
    </div>

    <h4 class="text-muted text-center my-4 white-space-normal">
      {{stats.description}}
    </h4>

    <canvas ref="chart"></canvas>
  </app-chart-wrapper>
</template>

<script>
    import interactionStat from './interaction-stat'
    import Chart from 'chart.js'
    import colors from '@packages/colors'
    import AppChartWrapper from '@components/chart/ChartWrapper'
    import EventBus from '@packages/event-bus/index'

    export default {
        mixins: [interactionStat],

        components: {
            AppChartWrapper,
        },

        data() {
            return {
                chartBackground: colors.charts.bar[0]
            }
        },

        computed: {
            data() {
                return {
                    datasets: [
                        {
                            backgroundColor: this.chartBackground,
                            data: this.values,
                        }
                    ],
                    labels: this.labels
                }
            }
        },

        methods: {

            openModalAnswersFromChart(_event, element){
                let dataAnswer = {
                    mode: this.mode,
                    interactionId : this.stats.interactionBody.id,
                    advertisingId : this.stats.campaignId,
                    answer : element[0]._model.label,
                    answers : this.data.labels
                }
                EventBus.$emit('OPEN_MODAL_ANSWERS', dataAnswer)
            },
            async buildChart() {
                if (this.chart)
                    await this.chart.destroy()

                const gridLines = {
                    color: 'transparent'
                }

                const options = {
                    legend: {
                        display: false
                    },
                    onClick: this.openModalAnswersFromChart,
                    scaleSteps : 1,
                    scales: {
                        yAxes: [
                            {
                                ticks: {
                                    beginAtZero: true,
                                    precision: 1,
                                    stepSize: 1,
                                    display: true,
                                },
                                gridLines,
                            }
                        ],
                        xAxes: [
                            {
                                gridLines,
                            }
                        ],
                    }
                }

                this.chart = await new Chart(this.$refs.chart, {
                        type: 'bar',
                        data: this.data,
                        options,
                    }
                )
            },
        },

        mounted() {
            this.buildChart()
        },
    }
</script>

<style lang="scss" scoped>
.card-header {
  align-items: center;

  .repetition {
    display: flex;
    align-items: center;
    flex-grow: 0;
  }
}

.card-body {
  display: grid;
  grid-template-columns: 4fr 6fr;

  .chart {
    display: flex;
    align-items: center;
  }
}
</style>
